export const kMovablePointClass = "movable-point"
export const kMovablePointType = "Movable Point"
export const kMovablePointPrefix = "ADRN"
export const kMovablePointLabelKey = "DG.Inspector.graphMovablePoint"
export const kMovablePointUndoAddKey = "DG.Undo.graph.showMovablePoint"
export const kMovablePointRedoAddKey = "DG.Redo.graph.showMovablePoint"
export const kMovablePointUndoRemoveKey = "DG.Undo.graph.hideMovablePoint"
export const kMovablePointRedoRemoveKey = "DG.Redo.graph.hideMovablePoint"
